<template>
  <b-container fluid>
    <main-modal id="bugDetails" size="lg">
      <template v-slot:header>
        <h4 class="font-weight-bold"><span class="text-success-light" >view: </span>Feedback</h4>
      </template>
      <template v-slot:body>
        <p class="text-black font-size-22 font-weight-bold m-0">{{bugDetails.user ? bugDetails.user.name: 'User'}}</p>
        <p class="font-size-16 font-weight-bold m-0">{{bugDetails.desc}}</p>
        <div class="d-flex">
          <img :src="bugDetails.image" class="mt-4" style="width: 200px; margin: auto">
        </div>

        <validationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(editFeedback)">
        <b-row>
          <b-col md="12" class="mb-3">
                <main-select
                  labelTitle='Status'
                  clearable
                  :validate="''"
                  :name="`Status`"
                  placeholder="Select Status"
                  class=""
                  label="name"
                  v-model="status"
                  :options="['Pending', 'Solved']"
                  >
                </main-select>
              </b-col>

          <b-col lg="12">

            <validation-provider
                #default="{ errors }"
                :name="`note`"
                :rules="''"
                class="flex-grow-1"
            >
              <b-form-group label="note">
                <b-form-textarea
                    v-model="note"
                    :label="'note'"
                    placeholder="Write your note…."
                    rows="2"
                    :class="[{ 'is-invalid': errors.length > 0 }]"
                ></b-form-textarea>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>


        <b-row>
          <b-col md="12" class="mt-4">
            <div
                class="d-flex justify-content-center"
            >
              <b-button
                  class="button-blue-modal"
                  type="submit"
                  v-if="!requestLoading"
              >
                <i class="las la-pen"></i>
              </b-button>
              <b-button class="button-blue-modal" v-else>
                <spinner-loading></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validationObserver>
      </template>
    </main-modal>
    <b-row>
      <b-col lg="12" class="mb-2">
        <h3>Feedback</h3>
      </b-col>
        <b-col lg="12" class="mb-2">
            <iq-card class="filter-card">
                <b-row>
                    <b-col md="3" sm="6">
                        <span>Filter by Type:</span>
                        <main-select v-model="filter.type" @change="reloadTable=true"
                                     :options="['provider', 'user']" label="key"
                                     placeholder="--Select--">
                        </main-select>
                    </b-col>
                </b-row>
            </iq-card>
        </b-col>
      <b-col lg="12">
        <main-table
            :fields="columns"
            @sortChanged="sortChanged"
            class="mb-0 table-borderless"
            :list_url="'supports'"
            :reloadData="reloadTable"
            :custom-filter="filter"
        >
            <template v-slot:type="{data}">
                {{data.facility ? 'Provider' : 'User'}}
            </template>
          <template v-slot:created_at="{data}">
            {{ data.created_at }}
          </template>
<!--            <template v-slot:user="{data}">-->
<!--                {{data.provider ? data.provider.name : data.user.name}}-->
<!--            </template>-->
        </main-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import feedbackServices from '../services/feedback'
export default {
  data () {
    return {
      bugDetails: {},
      requestLoading: false,
      reloadTable: false,
      status: '',
      note: '',
      filter: {
        type: '',
        sort: '',
        sort_type: ''
      },
      columns: [
        '#',
        // { label: 'User', key: 'user', class: 'text-left', type: 'custom' },
        // { label: 'Provider', key: 'provider.name', class: 'text-left' },
        { label: 'Type', key: 'type', class: 'text-left', type: 'custom' },
        { label: 'description', key: 'issue', class: 'text-left' },
        { label: 'Image', key: 'image', class: 'text-left', type: 'image' },
        { label: 'created date', key: 'created_at', class: 'text-left', sortable: true,  type: 'custom' },
        {label: 'Status', key: 'status', type: 'status' },
        {label: 'Admin', key: 'admin.name', type: 'status' },
        {
          label: 'Actions',
          key: 'actions',
          class: 'text-left',
          type: 'actions',
          actions: [
            {
              icon: 'las la-eye',
              color: 'success-light',
              text: 'View',
              actionName: 'showBug',
              actionParams: 'fullObj'
            },
            {
              icon: 'las la-trash-alt',
              color: 'danger',
              text: 'Delete',
              showAlert: true,
              actionHeader: 'Delete',
              titleHeader: 'Feedback',
              textContent: 'user.name',
              url: 'supports'
            }
          ]
        }
      ]
    }
  },
  methods: {
    editFeedback () {
      this.requestLoading = true
      feedbackServices.editFeedBacks(this.bugDetails.id, {
        status: this.status,
        note: this.note
      }).then((res) => {
        core.showSnackbar('success', res.data.message)
      }).finally(()=> {
        this.bugDetails = null
        this.requestLoading = false
        this.$bvModal.hide('bugDetails')
      })
    },
    sortChanged (key) {
      this.reloadTable = false
      this.filter.sort = key.sortBy
      this.filter.sort_type = key.sortDesc ? 'desc' : 'asc'
      this.reloadTable = true
    },
    showDetails (data) {
      this.bugDetails = data
      this.$bvModal.show('bugDetails')
    }
  },
  mounted () {
    core.index()
  },
  created () {
    this.$root.$on('showBug', this.showDetails)
  }
}
</script>
<style>
.max-w-100 {
  max-width: 100%;
}
</style>
